const axios = require('axios');
const { analyticsUrl, buildAuthHeaders } = require('./settings.js');

exports.getFunnelData = function (params) {
  return axios.post(analyticsUrl + `funnel`, params, {
    headers: buildAuthHeaders()
  });
};
